import { useEffect } from "react";
import { setToken } from "@/lib/api";

// Landing point for the central login app: stores the gateway token it put
// in the URL fragment, then does a full load so the app bootstraps signed in.
export default function SsoCallback() {
  useEffect(() => {
    const token = new URLSearchParams(window.location.hash.replace(/^#/, "")).get("token");
    if (token) {
      try { sessionStorage.setItem("hv_sso_cb", String(Date.now())); } catch { /* ignore */ }
      setToken(token);
      window.location.replace("/dashboard");   // the Stories dashboard, not the Today tab
    } else {
      window.location.replace("/login");
    }
  }, []);
  return null;
}
